// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__cITwE","footer":"styles_footer__1KPUJ","error":"styles_error__1OenU"};